export const searchFn = (search: string, data: any[]) => {
  const regex = new RegExp(search, 'i');

  return data?.filter((item) => {
    if (search === '') {
      return true;
    }

    return regex.test(item.entity.displayName);
  });
};
